import styled from "styled-components";

export const Styles = styled.div`
  .ant-radio-group {
    display: flex;
    background: #fff;
    border: 1px solid #ccc;
    padding-left: 8px;
    .ant-radio-wrapper {
      margin: 0px;
      span {
        white-space: nowrap;
      }
    }
  }

  .ant-checkbox-group {
    background: #fff;
  }
  padding: 2px;
`;
